import CardsListing from 'components/cards-listing';
import PaymentsHeader from 'components/payments-header';
import PaymentsHistory from 'components/payments-history';
import { useApp } from 'hooks';
import { useNavigate } from 'react-router-dom';
import routes from 'router/routes';
import { useEffect } from 'react';

export default function Payments() {
  const { isCardPaymentsAvailable } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isCardPaymentsAvailable) {
      navigate(routes.appointments.path);
    }
  });

  return (
    <>
      <PaymentsHeader />
      <CardsListing />
      <PaymentsHistory />
    </>
  );
}
